import * as _ from 'lodash';

import { PopoverItemData, IValueViewModel } from '../../models';

function escapeObject(obj: {}): {} {
    let res = undefined;

    if (obj) {
        res = {};

        Object.keys(obj).forEach(k => {
            const type = typeof obj[k];
            if (type === 'string') {
                res[k] = _.escape(obj[k]);
            } else if (type === 'object') {
                res[k] = escapeObject(obj[k]);
            } else {
                res[k] = obj[k];
            }
        });
    }

    return res;
}

/**
 * Try to ensure return a properly xml escaped item for popover
 * @param object
 */
export function popoverItem(object: PopoverItemData | IValueViewModel): string {
    return JSON.stringify(escapeObject(object));
}